"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Prompt = exports.Message = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _Collapse = _interopRequireDefault(require("@material-ui/core/Collapse"));
var _Report = _interopRequireDefault(require("@material-ui/icons/Report"));
var _ArrowDownward = _interopRequireDefault(require("@material-ui/icons/ArrowDownward"));
var _ArrowUpward = _interopRequireDefault(require("@material-ui/icons/ArrowUpward"));
var _Layout = require("./Layout");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Message = exports.Message = function Message() {
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement(_Layout.Container, {
    icon: /*#__PURE__*/_react["default"].createElement(_Report["default"], {
      className: "text-gray-light",
      fontSize: "small"
    })
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "font-bold text-sm"
  }, t('message.suspiciousDetecting.title')), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-xs"
  }, t('message.suspiciousDetecting.body')));
};
var Prompt = exports.Prompt = function Prompt() {
  var _useTranslation2 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation2.t;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isOpen = _useState2[0],
    setOpen = _useState2[1];
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "shadow-lg rounded overflow-hidden mb-10"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center justify-between bg-orange text-white font-semibold p-3 text-sm"
  }, /*#__PURE__*/_react["default"].createElement("div", null, t('message.suspiciousDetecting.tip')), /*#__PURE__*/_react["default"].createElement("div", {
    className: "cursor-pointer",
    onClick: function onClick() {
      return setOpen(function (isOpen) {
        return !isOpen;
      });
    }
  }, isOpen ? /*#__PURE__*/_react["default"].createElement(_ArrowUpward["default"], null) : /*#__PURE__*/_react["default"].createElement(_ArrowDownward["default"], null))), /*#__PURE__*/_react["default"].createElement(_Collapse["default"], {
    "in": isOpen
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "p-3 text-xs bg-pane"
  }, t('message.suspiciousDetecting.body'))));
};
//# sourceMappingURL=SuspiciousDetecting.js.map